import { createContext, useContext, useState, useEffect } from "react";
import { MyStudiesDefaults, LOADER_TYPES } from "app/shared/constants";
import { getMyStudies, getDashboardData } from "app/services/studiesService";
import { useUsers, useAlerts } from "common";
import { getStatusCategoryForMyStudies } from "app/shared/utils";
import { useNavigate } from "react-router-dom";

export const MyStudyContext = createContext();

const MyStudyProvider = ({ children }) => {
  const { currentUser } = useUsers();
  const { setAlert } = useAlerts();

  const [studyList, setStudyList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [dashboardData, setDashboardData] = useState(null);
  const [oncoreLastSyncTime, setOncoreLastSyncTime] = useState(null);

  const [initialLoad, setInitialLoad] = useState(true);

  const [sort, setSort] = useState({
    orderBy: MyStudiesDefaults.MYSTUDIESDEFAULTORDERBY,
    order: MyStudiesDefaults.MYSTUDIESDEFAULTORDER,
  });

  const [pagination, setPagination] = useState({
    page: MyStudiesDefaults.MYSTUDIESDEFAULTPAGE,
    rowsPerPage: MyStudiesDefaults.MYSTUDIESDEFAULTPAGESIZE,
  });

  const [isLoading, setIsLoading] = useState({
    [LOADER_TYPES.STUDY_DASHBOARD_DATA]: false,
    myStudiesDataLoading: false,
  });

  const navigate = useNavigate();

  const setLoader = (type, value) => {
    setIsLoading((prev) => ({ ...prev, [type]: value }));
  };

  useEffect(() => {
    getMyStudies(
      setStudyList,
      setTotalCount,
      setAlert,
      pagination,
      sort,
      setLoader,
      currentUser,
      initialLoad,
      navigate
    );
  }, [pagination, sort, currentUser, initialLoad, setAlert, navigate]);

  useEffect(() => {
    getDashboardData(
      (data) => {
        const transformed = {};
        Object.entries(data || {}).forEach(([status, count]) => {
          const category = getStatusCategoryForMyStudies(status);
          if (category) {
            transformed[category] = (transformed[category] || 0) + count;
          }
        });
        setDashboardData(transformed);
      },
      sort,
      setLoader,
      currentUser,
      setAlert,
      setOncoreLastSyncTime
    );
  }, [pagination, sort, currentUser, setAlert]);

  return (
    <MyStudyContext.Provider
      value={{
        studyList,
        totalCount,
        dashboardData,
        oncoreLastSyncTime,
        isLoading,
        pagination,
        setPagination,
        sort,
        setSort,
        initialLoad,
        setInitialLoad,
      }}
    >
      {children}
    </MyStudyContext.Provider>
  );
};

export const useStudyContext = () => useContext(MyStudyContext);

export default MyStudyProvider;
